import React, { useContext } from 'react'
import Slot from 'react-slot-machine'
import { modalContext } from 'global/context/sub-contexts/modalContext'

import './SlotMachine.scss'

const SlotMachine = ({ slotImages }) => {
  const modal_context = useContext(modalContext)
  const { slotsArray, defaultSlots, setSlotsOverlay } = modal_context || {}

  return (
    <>
      <div className="slot-machine">
        <Slot
          className="slot-container"
          duration={2000}
          target={defaultSlots ? 0 : slotsArray[0]}
          times={10}
        >
          {slotImages.map(({ name, path }) => (
            <div key={name} className="slot-item">
              <img src={path} alt=""></img>
            </div>
          ))}
        </Slot>
        <Slot
          className="slot-container"
          duration={4000}
          target={defaultSlots ? 0 : slotsArray[1]}
          times={10}
        >
          {slotImages.map(({ name, path }) => (
            <div key={name} className="slot-item">
              <img src={path} alt=""></img>
            </div>
          ))}
        </Slot>
        <Slot
          className="slot-container"
          duration={6000}
          target={defaultSlots ? 0 : slotsArray[2]}
          times={10}
          onEnd={() => {
            setSlotsOverlay(true)
          }}
        >
          {slotImages.map(({ name, path }) => (
            <div key={name} className="slot-item">
              <img src={path} alt=""></img>
            </div>
          ))}
        </Slot>
      </div>
    </>
  )
}
export default SlotMachine
